import type { DeepPartial } from '@luna/utils-ts';

import type { SavingsConfig } from '../ProductsConfig';
import { termDepositOverviewConfig } from './term-deposit-overview-config/SK';
import { settingsDetails } from './settings-details-config/SK';

export const savings: DeepPartial<SavingsConfig> = {
    showAccountFeatures: true,
    statements: {
        createStatement: false,
    },
    overview: {
        termDeposit: termDepositOverviewConfig,
        enabled: false,
    },
    allowedPurposeSavingsFlags: ['internationalTransferAllowed', 'domesticTransferAllowed'],
    associatedCards: {
        enabled: false,
    },
    cancellation: {
        options: {
            showCancellationTypeSelect: true,
        },
        signing: {
            showCancelledAccountInfo: true,
            showTargetAccountInfo: true,
        },
        error: {
            showBlockedInvestigation: true,
            showBlockedFraud: true,
            blockedInvestigationKey: 'account.signing.error_BLOCKED_INVESTIGATION',
            blockedFraudKey: 'account.signing.error_BLOCKED_FRAUD',
        },
        focusPage: {
            errorPageTitle: 'account.scheduledTermDepositCancelation.stripeErrorTitle',
            successPageTitle: 'account.details.services.cancellation.step1.modalHeadline',
            signingPageTitle: 'account.details.services.cancellation.step1.modalHeadline',
            optionsPageTitle: 'account.details.services.cancellation.step1.modalHeadline',
        },
        successMessage: 'account.details.services.cancellation.signing.success',
    },
    settingsDetails,
    newTransfer: {
        sideMenuLabel: 'savings.main.newWithdrawal',
    },
    layout: {
        productInfo: {
            showBalanceAndDisposableAmounts: true,
        },
    },
};
